// ---- Portfolio category cards (Home section thumbnails) -------------------
import Concept_Art from "../../../assests/portfolio_image/Th1.png";
import Two_d_arts from "../../../assests/portfolio_image/Th2.png";
import Three_d_arts from "../../../assests/portfolio_image/Th5.png";
import Animation_VFX from "../../../assests/portfolio_image/Th4.png";

// ---- Concept Art assets ----------------------------------------------------
import ConceptHero from "../../../assests/Concept/GP_Hero_Concept_Art_img.jpg";
import ConceptPortrait from "../../../assests/Concept/Concept.jpg";
import ConceptImg1 from "../../../assests/Concept/GP_Concept_Art_Img1.png";
import ConceptImg2 from "../../../assests/Concept/GP_Concept_Art_Img2.png";
import ConceptImg3 from "../../../assests/Concept/Gallary_page_v03.png";


// ---- 2D Art assets ---------------------------------------------------------
import TwoDHero from "../../../assests/2D_Art/GP_Hero_2D_Art_img.jpg";
import TwoDPortrait from "../../../assests/2D_Art/2Dart.jpg";
import TwoDImg1 from "../../../assests/2D_Art/GP_2D_Art_Img1.jpg";
import TwoDImg2 from "../../../assests/2D_Art/GP_2D_Art_Img2.jpg";
import TwoDImg3 from "../../../assests/2D_Art/GP_2D_Art_Img3.jpg";
import TwoDImg4 from "../../../assests/2D_Art/GP_2D_Art_Img4.jpg";
import TwoDImg5 from "../../../assests/2D_Art/GP_2D_Art_Img5.jpg";

// ---- 3D Art assets ---------------------------------------------------------
import ThreeDHero from "../../../assests/3D_Art/GP_Hero_3D_Art_img.jpg";
import ThreeDPortrait from "../../../assests/3D_Art/3Dart.jpg";
import ThreeDImg1 from "../../../assests/3D_Art/GP_3D_Art_Img1.jpg";
import ThreeDImg2 from "../../../assests/3D_Art/GP_3D_Art_Img2.jpg";
import ThreeDImg3 from "../../../assests/3D_Art/3D_page.png";
import ThreeDImg4 from "../../../assests/3D_Art/GP_3D_Art_Img3.jpg";
import ThreeDImageTitle from "../../../assests/3D_Art/3d_thumb1.jpg";


// ---- Animation_VFX assets ---------------------------------------------------------
import AnimationVFXHero from "../../../assests/Animation_&_VFX/GP_Hero_Animation_img.jpg";
import AnimationVFXPortrait from "../../../assests/Animation_&_VFX/Animations.jpg";
import AnimationVideoTitle2 from "../../../assests/Animation_&_VFX/anim_thumb2.jpg";
import AnimationVideoTitle3 from "../../../assests/Animation_&_VFX/anim_thumb3.jpg";
import AnimationVideoTitle4 from "../../../assests/Animation_&_VFX/anim_thumb4.jpg";




export interface PortfolioCategoryDef {
  id: string; // slug used in the route + filter
  label: string;
}

export interface PortfolioCategoryMeta {
  image: string;
  description: string;
}

export const PORTFOLIO_CATEGORIES: PortfolioCategoryDef[] = [
  { id: "concept-art", label: "Concept Art" },
  { id: "2d-art", label: "2D Art" },
  { id: "3d-art", label: "3D Art" },
  { id: "Animation_VFX", label: "Animation & VFX" },
];

export const CATEGORY_META: Record<string, PortfolioCategoryMeta> = {
  "concept-art": {
    image: Concept_Art,
    description: "Ideas, Sketches & Visual Development",
  },
  "2d-art": {
    image: Two_d_arts,
    description: "Symbols, Characters & Environments",
  },
  "3d-art": {
    image: Three_d_arts,
    description: "Characters, Props & Environments",
  },
  Animation_VFX: {
    image: Animation_VFX,
    description: "Symbols, Motion Graphics & Effects",
  },
};

export interface PortfolioItem {
  id: number;
  title: string;
  image: string;
  // YouTube video id (e.g. "S9gZeTMSY9c"). When present, the carousel streams
  // the video from YouTube via a lazy-loaded player instead of showing `image`.
  youtubeId?: string;
}

// Hero banner shown below the navbar on each category page.
export const CATEGORY_HERO: Record<string, string> = {
  "concept-art": ConceptHero,
  "2d-art": TwoDHero,
  "3d-art": ThreeDHero,
  "Animation_VFX": AnimationVFXHero,
};

// Hero portrait banner shown on mobile portrait view.
export const CATEGORY_HERO_PORTRAIT: Record<string, string> = {
  "concept-art": ConceptPortrait,
  "2d-art": TwoDPortrait,
  "3d-art": ThreeDPortrait,
  "Animation_VFX": AnimationVFXPortrait,
};

// Portfolio assets per category. Animation & VFX has no folder yet, so it
// borrows assets from the other categories as temporary placeholders.
export const CATEGORY_ITEMS: Record<string, PortfolioItem[]> = {
  "concept-art": [
    { id: 1, title: "Concept Art 01", image: ConceptImg1 },
    { id: 2, title: "Concept Art 02", image: ConceptImg2 },
    { id: 3, title: "Concept Art 03", image: ConceptImg3 },
  ],
  "2d-art": [
    { id: 1, title: "2D Art 01", image: TwoDImg1 },
    { id: 2, title: "2D Art 02", image: TwoDImg2 },
    { id: 3, title: "2D Art 03", image: TwoDImg3 },
    { id: 4, title: "2D Art 04", image: TwoDImg4 },
    { id: 5, title: "2D Art 05", image: TwoDImg5 },
  ],
  "3d-art": [
  
    { id: 1, title: "Character Turnaround", image: ThreeDImageTitle, youtubeId: "S9gZeTMSY9c" },
    { id: 2, title: "3D Art 01", image: ThreeDImg4 },
    { id: 3, title: "3D Art 02", image: ThreeDImg1 },
    { id: 4, title: "3D Art 03", image: ThreeDImg2 },
    { id: 5, title: "3D Art 04", image: ThreeDImg3 },

    
  ],
  "Animation_VFX": [
    { id: 1, title: "Animation & VFX 01", image: AnimationVideoTitle4, youtubeId: "rsnQQKD437w" },
    { id: 2, title: "Animation & VFX 02", image: AnimationVideoTitle2, youtubeId: "OVkQrB7Ge8U" },
    { id: 3, title: "Animation & VFX 03", image: AnimationVideoTitle3, youtubeId: "iKfzjwwFyqE"},
  ],
};

export const getCategory = (slug?: string): PortfolioCategoryDef | undefined =>
  PORTFOLIO_CATEGORIES.find((category) => category.id === slug);

export const getHeroForCategory = (slug?: string): string =>
  (slug && CATEGORY_HERO[slug]) || ThreeDHero;

export const getHeroPortraitForCategory = (slug?: string): string =>
  (slug && CATEGORY_HERO_PORTRAIT[slug]) || ThreeDPortrait;

export const getItemsForCategory = (slug?: string): PortfolioItem[] =>
  (slug && CATEGORY_ITEMS[slug]) || [];
